<script lang="ts" setup>
import type { IProps } from './home-textWithImageColumns.types'

withDefaults(defineProps<IProps>(), {
  layout: 'default',
  layoutNumbers: 'default',
})

const { isMobile } = useBSBreakpoints()

</script>

<template>
  <UiSection>
    <div
      :class="[
        'text-with-image',
        `text-with-image__layout--${layout}`
      ]"
    >
      <div class="text-with-image__wrapper">
        <div class="text-with-image__left">
          <UiHeader
            :header="header"
            position="left"
          />

          <div
            v-if="isMobile"
            class="text-with-image__images"
          >
            <img
              :src="image"
            >
            <img
              v-if="image2"
              :src="image2"
            >
          </div>

          <p class="text-with-image__text">
            {{ text }}
          </p>

          <UiButton
            v-if="button && !isMobile"
            :to="button.to"
          >
            {{ button.text }}
          </UiButton>
        </div>
        <div class="text-with-image__right">
          <div
            v-if="!isMobile"
            class="text-with-image__images"
          >
            <img
              :src="image"
            >
            <img
              v-if="image2"
              :src="image2"
            >
          </div>
          <UiList
            v-if="list"
            :list="list"
          />
        </div>
      </div>
      <UiNumbers
        v-if="numbers"
        :layout="layoutNumbers"
        :numbers="numbers"
      />

      <UiButton
        v-if="isMobile && button.text"
        :to="button.to"
      >
        {{ button.text }}
      </UiButton>
    </div>
  </UiSection>
</template>

<style lang="scss" scoped>
.text-with-image {
  $root: &;

  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin: 0 auto;

  &__layout {
    &--default {
      max-width: 115.2rem;

      @include atXL {
        max-width: 134rem;
      }

      :deep(.numbers) {
        margin: 0 0 3.2rem;

        @include atXS {
          margin: 3.2rem 0 0;
        }
      }
    }

    &--layout-1 {
      @include atM {

        #{$root}__left {
          padding-left: 7.2rem;
        }

        #{$root}__wrapper {
          align-items: flex-start;
        }
      }
    }
  }

  &__wrapper {
    display: flex;
    flex-direction: column;

    @include atM {
      flex-direction: row;
      align-items: center;
      gap: 8rem;
    }

    @include atXL {
      gap: 14.5rem;
    }
  }

  &__left {
    display: flex;
    flex-direction: column;
    @include atM {
      width: 50%;
    }
  }

  &__right {

    @include atM {
      width: 50%;
    }
  }

  &__img {
    margin-top: 4rem;
  }

  &__images {
    display: flex;
    gap: 1.6rem;
    margin-top: 4rem;
    img {
      flex: 1;
      width: calc(50% - 0.8rem);
      border-radius: 2rem;
      object-fit: cover;
      object-position: left;
    }

    @include atM {
      gap: 2.4rem;
      margin: 0;
    }
  }

  &__text {
    margin-top: 3.2rem;
    margin-bottom: 3rem;
    font-weight: 500;
    font-size: 2rem;
    line-height: 2.8rem;

    @include atM {
      margin-top: 4rem;
      margin-bottom: 4.6rem;
      font-size: 2rem;
      line-height: 2.8rem;
    }

    @include atXL {
      margin-bottom: 7.2rem;
      font-size: 2.4rem;
      line-height: 3.2rem;
    }
  }

  .button {
    align-self: center;
    margin-top: 3.2rem;

    @include atM {
      align-self: self-start;
      margin-top: 0;
    }
  }
}
</style>
